import { render } from "./TreeDictionary.vue?vue&type=template&id=19f56372&scoped=true"
import script from "./TreeDictionary.vue?vue&type=script&lang=js"
export * from "./TreeDictionary.vue?vue&type=script&lang=js"

import "./TreeDictionary.vue?vue&type=style&index=0&id=19f56372&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f56372"],['__file',"src/components/h5/data/TreeDictionary.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19f56372"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19f56372', __exports__)) {
    api.reload('19f56372', __exports__)
  }
  
  module.hot.accept("./TreeDictionary.vue?vue&type=template&id=19f56372&scoped=true", () => {
    api.rerender('19f56372', render)
  })

}


export default __exports__